import React from "react";
import styled from "styled-components";
import Slide from "react-reveal/Slide";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// style
const StyledRetouchingImage = styled.div`
  img {
    width: 90vw;
    margin: 0.5rem 0;
  }

  // tablet
  @media screen and (min-width: 768px) {
    img {
      width: 70vw;
    }
  }

  // 720
  @media screen and (min-width: 1366px) {
    img {
      height: 14vh;
      width: auto;
      margin: 0 1rem;
    }
  }

  // 1080
  @media screen and (min-width: 1920px) {
    img {
      height: 14vh;
      width: auto;
    }
  }
`;

const RetouchingImage = ({ image }) => {
  return (
    <StyledRetouchingImage>
      <Slide bottom>
        <div className="zoomed-image">
          <Zoom overlayBgColorEnd="rgba(0, 0, 0, 0.8)">
            <img src={image} alt="gallery" height="100%" />
          </Zoom>
        </div>
      </Slide>
    </StyledRetouchingImage>
  );
};

export default RetouchingImage;
